import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { defineComponent } from 'vue';

import { Authority, Featured, Task } from '@skinsoft/types';
import { authoritySelectors, taskSelectors } from '@skinsoft/selectors';
import { AuthorityDataStore } from '@skinsoft/entity';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { EntityFeaturedCard } from '@skinsoft/ui';
import { toFeatured$ } from '../../serializer/featured';

export const TaskFeaturedCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEntityFeaturedCard: EntityFeaturedCard,
    },
    template: require('./task-featured-card.html'),
    data() {
        return {
            serializer: (task: Task) => toFeatured$(task, ''), // '' just for avoiding problem with this at initialization
        }
    },
    mounted() {
        // passing directly this.getAppLocale() to the toFeatured inside the serializer arrow function
        // was not working as "this" was not pointing to the live component at data() initialization time
        const locale = this.getAppLocale()
        this.serializer = (task: Task) => toFeatured$(task, locale)
    },
    methods: {
        overrideSerializer(task: Task): Observable<Featured> {
            return toFeatured$(task, this.getAppLocale()).pipe(
                switchMap(featured => {
                    if(featured.author) {
                        const authorId: string | undefined | null = taskSelectors.author(task)
                        if(authorId) {
                            return AuthorityDataStore.getInstance().fetchByUser(authorId).pipe(
                                switchMap(searchResponse => {
                                    let res: Authority[] = []
                                    if(searchResponse.allData && searchResponse.allData.length > 0) {
                                        res = searchResponse.allData
                                    }
                                    else if(searchResponse.results && searchResponse.results.length > 0) {
                                        res = searchResponse.results
                                    }

                                    if(res.length > 0) {
                                        let authority = res[0]
                                        const alias = authoritySelectors.firstAlias(authority)
                                        if(alias) {
                                            const value = authoritySelectors.firstAliasCompleteValue(authority, this.getAppLocale())
                                            if(value) {
                                                featured.author = value
                                            }
                                        }
                                    }

                                    return of(featured)
                                })
                            )
                        }
                    }

                    return of(featured)
                })
            )
        },
    },
})
